/* Radiate Your Light Creations — v6.42 dual Healing Barn / Spa + sensory intensity */
(() => {
  const EXPERIENCE_KEY = 'rylExperienceModeV1';
  const SENSORY_KEY = 'rylHealingBarnModeV2';
  const html = document.documentElement;

  const normalizeExperience = (value) => value === 'barn' ? 'barn' : 'spa';
  const normalizeSensory = (value) => ['full', 'quiet', 'still'].includes(value) ? value : 'quiet';
  const read = (key, fallback) => { try { return localStorage.getItem(key) || fallback; } catch (_) { return fallback; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch (_) {} };

  const syncExperienceControls = (value) => {
    document.querySelectorAll('[data-ryl-experience-set]').forEach((control) => {
      if (control.tagName === 'BUTTON') control.setAttribute('aria-pressed', String(control.dataset.rylExperienceSet === value));
    });
    document.querySelectorAll('[data-ryl-experience-status]').forEach((node) => {
      node.textContent = value === 'barn' ? 'Healing Barn atmosphere' : 'Spa atmosphere';
    });
  };

  const syncSensoryControls = (value) => {
    document.querySelectorAll('[data-ryl-sensory-set]').forEach((control) => {
      if (control.tagName === 'BUTTON') control.setAttribute('aria-pressed', String(control.dataset.rylSensorySet === value));
    });
    document.querySelectorAll('[data-ryl-sensory-status]').forEach((node) => {
      node.textContent = `${value.charAt(0).toUpperCase()}${value.slice(1)} sensory setting`;
    });
  };

  const applyExperience = (value, persist = true) => {
    const mode = normalizeExperience(value);
    html.dataset.rylExperience = mode;
    if (persist) write(EXPERIENCE_KEY, mode);
    syncExperienceControls(mode);
    return mode;
  };

  const applySensory = (value, persist = true) => {
    const mode = normalizeSensory(value);
    html.dataset.rylSensory = mode;
    if (persist) write(SENSORY_KEY, mode);
    syncSensoryControls(mode);
    return mode;
  };

  applyExperience(html.dataset.rylExperience || read(EXPERIENCE_KEY, 'spa'), false);
  applySensory(html.dataset.rylSensory || read(SENSORY_KEY, 'quiet'), false);

  document.addEventListener('click', (event) => {
    const experienceControl = event.target.closest('[data-ryl-experience-set]');
    if (experienceControl) applyExperience(experienceControl.dataset.rylExperienceSet);

    const sensoryControl = event.target.closest('[data-ryl-sensory-set]');
    if (sensoryControl) {
      const value = applySensory(sensoryControl.dataset.rylSensorySet);
      const barnControl = document.querySelector(`[data-ryl-barn-mode-set="${value}"]`);
      if (barnControl) barnControl.click();
    }
  });

  document.addEventListener('ryl:experience-change', (event) => applyExperience(event.detail?.mode));
  document.addEventListener('ryl:sensory-change', (event) => applySensory(event.detail?.mode));
})();
